import {OperatingAreaEntity} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {BaseEntityMultiSelect, BaseEntityMultiSelectProps} from "../base-entity-multi-select";

export type BaseOperatingAreaMultiSelectProps = Omit<
  BaseEntityMultiSelectProps<OperatingAreaEntity>,
  'nameMapper'
>;

export const BaseOperatingAreaMultiSelect = (props: BaseOperatingAreaMultiSelectProps) => {
  const nameMapper = useCallback((e: OperatingAreaEntity) => {
    return e.name;
  }, []);

  return <BaseEntityMultiSelect nameMapper={nameMapper} {...props} />;
};
